module.exports = __webpack_public_path__ + "img/rihua3.6cb4c371.jpg";